import { type ZodError } from "zod";

import { type PromoCodesCreateFormFieldErrors, type PromoCodesCreateFormType } from "./PromoCodesCreate.types";

export const mapZodErrors = (error: ZodError): PromoCodesCreateFormFieldErrors => {
  const errors: PromoCodesCreateFormFieldErrors = {};

  for (const issue of error.issues) {
    const field = issue.path[0];

    if (typeof field === "string" && !errors[field as keyof PromoCodesCreateFormType]) {
      errors[field as keyof PromoCodesCreateFormType] = issue.message;
    }
  }

  return errors;
};
